module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/239-montenegro-01d134be821b1dec11fde645e3a56931.svg";